<template>
  <div>
    <portlet
        :icon="'fal fa-lightbulb portlet-icon'"
        :title="$t('improvements.improvements')"
        :actions-block="true"
        :fullheight="true"
        class="portlet-pt-20"
    >
      <template slot="actionsBlock">

        <button class=" btn btn-secondary   " @click="$router.go(-1)">
          {{ $t('ui.back') }}
        </button>

      </template>
      <template slot="portletBody">
        <ImprovementForm></ImprovementForm>
      </template>
    </portlet>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';

import ImprovementForm from "@/components/improvements/ImprovementForm";

export default {
  name: 'createImprovement',
  mixins: [],
  components: {
    ImprovementForm
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters('company', [
      'getConfig',
      'getActivities'
    ]),

    ...mapGetters('jobs', [

      'getJob',
    ]),
    ...mapGetters('users', [
      'getMe',
      'getClaims',
    ]),

  },
  methods: {},

  created() {

  }
};
</script>

<style scoped>

</style>